import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface UseRestockManagementProps {
  sampleData: any[];
  setSampleData: (data: any[]) => void;
  selectedItem: any;
  onClose: () => void;
}

export const useRestockManagement = ({
  sampleData,
  setSampleData,
  selectedItem,
  onClose
}: UseRestockManagementProps) => {
  const handleRestockConfirm = async (quantity: number) => {
    if (!selectedItem) return;

    try {
      // Mettre à jour dans Supabase
      const { error } = await supabase
        .from('stock_items')
        .update({ 
          quantity: selectedItem.quantity + quantity
        })
        .eq('id', selectedItem.id);

      if (error) throw error;

      // Mettre à jour l'état local
      const updatedData = sampleData.map(item => {
        if (item.id === selectedItem.id) {
          return {
            ...item,
            quantity: item.quantity + quantity
          };
        }
        return item;
      });

      setSampleData(updatedData);
      toast.success("Stock mis à jour avec succès");
      onClose();
    } catch (error) {
      console.error("Erreur lors de la mise à jour du stock:", error);
      toast.error("Erreur lors de la mise à jour du stock");
    }
  };

  return { handleRestockConfirm };
};